export const GET_QUERY_OBJECT = (location) => {
    let data = {}
    if (!location) return data
    decodeURIComponent(location)
        .replace(/^[?]/, "")
        .split('&')
        .forEach(el => {
            let [key, value] = el.split('=')
            data[key] = decodeURI(value)
        })
    return data
}

export const CURRENT_URL = () => location.origin + location.pathname

export const GET_QUERY_OBJECT_VALUE = (key, location) => {
    if (!location) return ''
    let location_obj = GET_QUERY_OBJECT(location.slice(1))
    return location_obj[key] || ''
}

export const REPLACE_IN_QUERY = (location, key, val) => {
    let query_obj = GET_QUERY_OBJECT(location),
        index = 0,
        new_query = ''
    query_obj[key] = val
    for (let [key, value] of Object.entries(query_obj)) {
        if (!!value) {
            new_query += `${index ? '&' : '?'}${key}=${value}`
            index++
        }
    }
    return new_query
}

export const REPLACE_STATE = (query) => {
    history.replaceState({}, '', `${location.origin}${location.pathname}${query}`)
}
